import { useEffect, useMemo, useState } from 'react';
import { get } from '@eika-infrastruktur/request';
import { GraphData, GraphDataApi, GraphDataPeriod } from '../../../../../../domain/Fund';
import { GraphDataPeriodMap, mapApiToData } from './graphUtils';

type GraphDataCache = Record<string, Record<GraphDataPeriod, GraphData>>;

type GraphDataHookProps = {
    isin: string;
    period: GraphDataPeriod;
};

export const useFundGraphData = ({ isin, period }: GraphDataHookProps) => {
    const url = useMemo(
        () =>
            `/sparing-min-side-web/rest/resource/fond/historisk/${isin}/${GraphDataPeriodMap[period]?.months}/${GraphDataPeriodMap[period]?.resolution}`,
        [isin, period]
    );

    const [pending, setPending] = useState(true);
    const [previouslyLoaded, setPreviouslyLoaded] = useState(false);
    const [error, setError] = useState<string | undefined>();
    const [graphDataCache, setGraphDataCache] = useState<GraphDataCache>({});
    const currenGraphData = useMemo(() => graphDataCache[isin]?.[period], [isin, period, graphDataCache]);

    useEffect(() => {
        if (period && isin && GraphDataPeriodMap[period] && !graphDataCache[isin]?.[period]) {
            setError(undefined);
            setPending(true);
            get<GraphDataApi>(url)
                .then((apiData) => {
                    setGraphDataCache((state) => ({
                        ...state,
                        [isin]: { ...(state?.[isin] || {}), [period]: mapApiToData(apiData) },
                    }));
                    setPreviouslyLoaded(false);
                })
                .catch((error) => setError(error.message))
                .finally(() => setPending(false));
        }
        if (graphDataCache[isin]?.[period]) setPreviouslyLoaded(true);
    }, [isin, period, graphDataCache]);

    return { graphData: currenGraphData, pending, previouslyLoaded, error };
};
